;(function () {
  window.Ateed.Components.IndexCard = function() {

    var $indexCard = $('.field-collection-item--name-field-index-card');
    var $imageOverlays = $('.ateed-image-card-bg-img-container--active-overlay');
    var $graphHolder = $('.graph_holder');
    var $graphHeading = $('.active_graph_header');
    var $share = $('.share');
    var $mapCheckbox = $('.map_show_all');
    var $mapFilterText = $('.filter_text');
    var $activeGraph;
    var $activeGraphHeading;
    var $activeCard;
    var $graphIndex;
    var height;

    var shareID;
    var sharePart;

    var $socialMediaAnchor = $('.facebook, .linkedin, .twitter');
    var origin = window.location.protocol + '//' + window.location.host + window.location.pathname;


    $.urlParam = function(name){
      var results = new RegExp('[\?&]' + name + '=([^]*)').exec(window.location.href);
      if (results==null) {
         return null;
      }
      else {
         return results[1] || 0;
      }
    };


    function addListeners() {

      $share.click(function() {
        $(this).find('.share-links').toggleClass('active');
      })

      $indexCard.click(function() {

        $activeCard = $(this).find('.ateed-image-card-bg-img-container--active-overlay');
        $graphIndex = $(this).index('.field-collection-item--name-field-index-card');

        $activeGraph = $('#graph_' + $graphIndex);
        $activeGraphHeading = $('#active_graph_header_' + $graphIndex);

        if ($activeCard.hasClass('active')) {
          $activeCard.removeClass('active');
          $activeGraph.removeClass('visible');
          $activeGraphHeading.removeClass('visible');
          //$activeGraph.css('height','0px');
          $activeGraph.css('height','');
          return;
        }

        $imageOverlays.removeClass('active');
        $activeCard.addClass('active');

        showGraph($graphIndex);
        $('html, body').animate({scrollTop:0}, 700);


      });

      // social share popup
      $socialMediaAnchor.click(function(e) {

        e.preventDefault();
        window.open($(this).attr('href'), 'Share', 'width=560,height=624,resizable=true').focus();

      });

      $mapCheckbox.click(function() {

        // if(!$(this).is(":checked")){
          $mapFilterText.removeClass('active').addClass('active');
        // }

      });

      $mapFilterText.click(function() {
        $mapFilterText.removeClass('active');
        $(this).addClass('active');

      });

      // get share fragment urls then add them to the share links
      //$( window ).load(function() {

        $('.field-collection-item--name-field-index-card').each( function(index, elem) {

          // get src
          //var $index = $(this).index('.field-collection-item--name-field-index-card');

          //console.log($index);

          var shareID = $(this).attr('id');
          var shareFragment = shareID.replace('graph_', '');

          //console.log(shareFragment);

          var $facebook = $('#active_graph_header_' + index + ' a.facebook');
          var $twitter = $('#active_graph_header_' + index + ' a.twitter');
          var $linkedin = $('#active_graph_header_' + index + ' a.linkedin');
          var $email = $('#active_graph_header_' + index + ' a.email');
          var shareLink = origin + '?graph=' + shareFragment;

          $facebook.attr('href', 'http://www.facebook.com/sharer/sharer.php?u=' + shareLink);
          $twitter.attr('href', 'http://twitter.com/share?text='+encodeURIComponent($('.field--name-field-index-card-title',this).text()+' via the @Auckland_NZ Index #aklindex')+'&url=' + shareLink);
          $linkedin.attr('href', 'http://www.linkedin.com/shareArticle?mini=true&url=' + shareLink);
          //$email.attr('href', 'mailto:recipient@email.com?&subject=subject&body=' + shareLink);
          $email.attr('href', 'mailto:?subject=Auckland%20Index%20-%20'+encodeURIComponent($('.field--name-field-index-card-title',this).text())+'&body=I found this graph on ' + encodeURIComponent($('.field--name-field-index-card-title',this).text()) + ' from the Auckland Index interesting:%0D%0A' + shareLink);

          // if we have an infogram iframe

        })

      //})

    }

    function showGraph(index) {

      $graphHolder.removeClass('visible');
      $graphHolder.css('height','0px');
      $graphHeading.removeClass('visible');

      if ($('#graph_' + index + ' .infogram-embed iframe').length > 0) {
        // get height of iframe

        height = $('#graph_' + index + ' .infogram-embed iframe').css('height');

        // trim off bottom so we can hide infogram's share button

        height = parseInt(height);
        /*if (height > 130) {
          height -= 90;
        }*/

        //console.log(height);

        $activeGraph.addClass('visible');
        $activeGraphHeading.addClass('visible');
        $activeGraph.css('height', height + 'px');

        // observe iframe mutations
        if (!$activeGraph.attr('mutation-registered')) {

          var target = document.querySelector('#graph_' + index + ' .infogram-embed iframe');

          // listen for change in height of iframe
          if (target != null) {
            var observer = new MutationObserver(function (mutations) {
              mutations.forEach(function(mutation) {
                //console.log(mutation);
                if ($('#graph_'+index).hasClass('visible')) {
                  $('#graph_'+index).css('height', parseInt(mutation.target.clientHeight) + 'px');
                }
              });
           });

            // configuration of the observer:
            var config = { attributes: true };

            // pass in the target node, as well as the observer options
            observer.observe(target, config);
            $activeGraph.attr('mutation-registered','true');
            // observer.disconnect();
          }

        }

      } else {
        $activeGraph.addClass('visible');
        $activeGraphHeading.addClass('visible');
        $activeGraph.css('height','auto');
      }

    }

    addListeners();

    var graphParam = $.urlParam('graph');
    if (graphParam) {
      graphParam = decodeURIComponent(graphParam);
      if ($('.field-collection-item--name-field-index-card#graph_'+graphParam).length > 0) {
        $('.field-collection-item--name-field-index-card#graph_'+graphParam).click();
      }
    }

  }
})();
